import store from '@/Store'

const setupApp = store.state.SetupApp

const detalheSolicitacao = async (idFuncionalidade, idRegistro) => {
  const response = await setupApp.apiSolicitacao.detalheSolicitacao({
    headers: {
      id_funcionalidade: idFuncionalidade,
      id_ocorrencia: idRegistro
    },
    loading: true,
    handlerErrorIgnore: true
  })
  return response.data
}

const acionaFuncionalidade = async (req) => {
  const data = {
    type: 'texto',
    message: `${req.data.textoWidget}`
  }
  return { status: true, data, message: 'sucesso' }
}

export {
  detalheSolicitacao,
  acionaFuncionalidade
}
